module.exports = __webpack_public_path__ + "img/no_data.d6b6d9de.png";